export function tallest(values) {
  return Math.ceil(Math.max(0, ...values));
}

if (typeof document !== 'undefined') {
  const observed = new Set();
  let pending = false;
  const updateSize = (card, name, value) => {
    const pixels = `${value}px`;
    if (card.style.getPropertyValue(name) !== pixels) card.style.setProperty(name, pixels);
  };
  const details = card => card.querySelector('.product-card__content > .group-block');
  const title = card => details(card)?.querySelector('[ref="productTitleLink"] .text-block');
  const price = card => details(card)?.querySelector('product-price [ref="priceContainer"]');
  const height = element => element?.getBoundingClientRect().height || 0;

  function alignRows() {
    pending = false;
    for (const element of observed) if (!element.isConnected) {
      resizeObserver.unobserve(element);
      observed.delete(element);
    }
    const roots = new Map();
    for (const card of document.querySelectorAll('[data-mm-eyewear-card]')) {
      const bounds = card.getBoundingClientRect();
      if (!bounds.width || !bounds.height || card.closest('[product-grid-view="zoom-out"]')) continue;
      const root = card.closest('.product-grid, .resource-list, .resource-list__carousel') || card.parentElement.parentElement;
      if (!roots.has(root)) roots.set(root, new Map());
      const rows = roots.get(root);
      const top = Math.round(bounds.top - root.getBoundingClientRect().top);
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push(card);
      for (const element of [card, title(card), price(card), details(card)?.querySelector('.group-block-content'), card.querySelector('.mm-versace-variant-preview')]) {
        if (element && !observed.has(element)) {
          observed.add(element);
          resizeObserver.observe(element);
        }
      }
    }
    // Measure natural text first; full titles are never truncated to force alignment.
    for (const rows of roots.values()) for (const cards of rows.values()) {
      const titleHeight = tallest(cards.map(card => height(title(card))));
      const priceHeight = tallest(cards.map(card => height(price(card))));
      for (const card of cards) {
        updateSize(card, '--mm-card-title-height', titleHeight);
        updateSize(card, '--mm-card-price-height', priceHeight);
      }
      const detailHeight = tallest(cards.map(card => height(details(card)?.querySelector('.group-block-content'))));
      const optionHeight = Math.max(80, tallest(cards.map(card => height(card.querySelector('.mm-versace-variant-preview')))));
      for (const card of cards) {
        updateSize(card, '--mm-card-detail-height', detailHeight);
        updateSize(card, '--mm-card-option-height', optionHeight);
      }
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(alignRows);
  }

  const resizeObserver = new ResizeObserver(schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('load', schedule, true);
  document.fonts?.ready.then(schedule);
  schedule();
}
